const initialState = {

};

export function fetchFrontendConfig(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_FRONTEND_CONFIG.SUCCESS':

      return {
        ...state,
        ...action.config.body,
      };
    default:
      return state
  }
}
